import {globalCatch} from "../../../_services/global-catch";
import {svcPsService} from "../../../_services/ps-service";
import {SET_ACADEMIC_PROGRAM_CERTIFICATES} from "./constants";
import {certificatesApi} from "../../../_services/expedient-service";

export const setAcademicProgramCertificates = ({academicProgramId, certificates}) => ({
  type: SET_ACADEMIC_PROGRAM_CERTIFICATES,
  payload: { academicProgramId, certificates }
});

export const fetchAcademicProgramCertificates = academicProgramId =>
    globalCatch.catch(async dispatch => {
        const certificates = await (await certificatesApi())
            .certificatesControllerGetAcademicProgramCertificates(academicProgramId);

        dispatch(setAcademicProgramCertificates({academicProgramId, certificates}));
        return certificates;
    });

export const createCertificateCart = (academic_program_id, product_attribute_id) =>
    globalCatch.catch(async () =>
        (await svcPsService()).createCertificateCart(academic_program_id, product_attribute_id)
    );

export const requestDigitalCertificate = (academicProgramId, productAttributeId) =>
    globalCatch.catch(async (dispatch) => {
       await (await certificatesApi()).certificatesControllerRequestAcademicProgramCertificate(
           academicProgramId,
           {id_product_attribute: Number(productAttributeId)}
       );

       return dispatch(fetchAcademicProgramCertificates(academicProgramId));
    });
